export default __webpack_public_path__ + "static/media/np.aec553b1.svg";